/* unplugin-vue-components disabled */import { render } from "./SysCogStatus.vue?vue&type=template&id=0f8731a4&scoped=true"
import script from "./SysCogStatus.vue?vue&type=script&lang=js"
export * from "./SysCogStatus.vue?vue&type=script&lang=js"

import "./SysCogStatus.vue?vue&type=style&index=0&id=0f8731a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8731a4"]])

export default __exports__